import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import WaterIcon from "@mui/icons-material/Water";
import image1 from "../../../assets/images/pond.jpg";
import image2 from "../../../assets/images/microscope.png";

const About = () => {
  const ColorButton2 = styled(Button)(() => ({
    color: "#fff",
    width: 180,
    height: 55,
    fontWeight: 700,
    fontSize: "16px",
    textTransform: "capitalize",
    backgroundColor: "#9DCC49",
    borderColor: "#9DCC49",
    "&:hover": {
      color: "#fff",
      backgroundColor: "#317ABE",
      borderColor: "#317ABE",
    },
  }));

  return (
    <Box paddingTop={{ xs: "25%", sm: "12%" }}>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignCenter={"center"}
        flexWrap={"wrap"}
        width={"100%"}
      >
        <Box width={{ xs: "100%", sm: "24%" }}>
          <Box
            component="img"
            height={{ xs: "30vh", sm: "600px" }}
            display={{ xs: "none", sm: "block" }}
            sx={{
              objectFit: "cover",
              position: "relative",
              overflow: "hidden",
              borderRadius: "5px",
              width: "100%",
            }}
            src={image1}
            alt={"about-image"}
          />
        </Box>
        <Box width={{ xs: "100%", sm: "24%" }}>
          <Box
            component="img"
            height={{ xs: "30vh", sm: "600px" }}
            display={{ xs: "none", sm: "block" }}
            sx={{
              objectFit: "cover",
              position: "relative",
              overflow: "hidden",
              borderRadius: "5px",
              marginTop: "15%",
              width: "100%",
            }}
            src={image2}
            alt={"about-image"}
          />
        </Box>
        <Box
          width={{ xs: "100%", sm: "40%" }}
          marginTop={{ xs: "25%", sm: "0%" }}
        >
          <Typography
            variant="h6"
            color="#9DCC49"
            fontWeight={800}
            paddingTop={{ xs: "0%", sm: "1%" }}
            paddingBottom={"2%"}
            textAlign={"left"}
          >
            {" "}
            <Box component={"span"}>
              <WaterIcon
                sx={{
                  width: 23,
                  height: 23,
                }}
              />
            </Box>{" "}
            About Us
          </Typography>
          <Typography
            variant="h3"
            color="#317ABE"
            fontWeight={800}
            paddingTop={"2%"}
            paddingBottom={"2%"}
            textAlign={"left"}
          >
            Connecting the Blue Economy to Create a Greener Future
          </Typography>
          <Typography
            variant="body1"
            color="#000"
            fontWeight={400}
            paddingTop={"2%"}
            paddingBottom={"2%"}
            lineHeight={1.75}
            textAlign={"left"}
          >
            Since 2019, the Blue Echo Foundation has been at the forefront of
            providing Nigerian farmers with the tools necessary for sustainable
            aquaculture, with a focus on cage culture, feed efficiency, and
            market development. With a strong physical presence in nine states,
            we have built a network of fish entrepreneurs who generate revenue
            while contributing to Nigeria’s nutritional needs. According to the
            FAO, the optimal per capita fish consumption should be 20.5 kg,
            meaning Nigeria faces a total fish supply deficit of approximately
            4.5 million metric tons. Our goal is to address at least 15% of this
            gap within the next four years.
          </Typography>
          <Box padding={{ xs: "5% 0% 1% 1%", sm: "2% 0% 1% 0%" }}>
            <ColorButton2
              component={"a"}
              variant="contained"
              size="medium"
              href={"/about-us"}
              endIcon={
                <ArrowRightAltIcon
                  sx={{
                    color: "#fff",
                    height: "32px",
                    width: "32px",
                    "&:hover": {
                      color: "#fff",
                    },
                  }}
                />
              }
            >
              Read More
            </ColorButton2>
          </Box>
        </Box>
        <Box width={{ xs: "100%", sm: "24%" }}>
          <Box
            component="img"
            height={{ xs: "70vh", sm: "70vh" }}
            display={{ xs: "block", sm: "none" }}
            sx={{
              objectFit: "cover",
              position: "relative",
              overflow: "hidden",
              borderRadius: "5px",
              marginTop: "15%",
              width: "100%",
            }}
            src={image2}
            alt={"about-image"}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default About;
